import {
  CreateDataBridgesApiKeyPayload,
  DataBridgesApiKeyList,
  UpdateDataBridgesApiKeyPayload,
} from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const apiKeyApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    createDataBridgesApiKey: builder.mutation<void, CreateDataBridgesApiKeyPayload>({
      query: body => ({
        url: "ApiKey/Create",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "DataBridgesApiKeys" as const, id: "LIST" }],
    }),

    getDataBridgesApiKeys: builder.query<DataBridgesApiKeyList[], void>({
      query: () => ({
        url: "ApiKey/GetByUser",
        method: "GET",
      }),
      providesTags: [{ type: "DataBridgesApiKeys" as const, id: "LIST" }],
    }),

    updateDataBridgesApiKey: builder.mutation<void, UpdateDataBridgesApiKeyPayload>({
      query: body => ({
        url: "ApiKey/Update",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "DataBridgesApiKeys" as const, id: "LIST" }],
    }),

    deleteDataBridgesApiKey: builder.mutation<void, number>({
      query: apiKeyId => ({
        url: `ApiKey/Delete/${apiKeyId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "DataBridgesApiKeys" as const, id: "LIST" }],
    }),
  }),
})

export const {
  useCreateDataBridgesApiKeyMutation,
  useGetDataBridgesApiKeysQuery,
  useUpdateDataBridgesApiKeyMutation,
  useDeleteDataBridgesApiKeyMutation,
} = apiKeyApi
